import script from "./AddZeroReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddZeroReport.vue?vue&type=script&setup=true&lang=ts"

import "./AddZeroReport.vue?vue&type=style&index=0&id=a1bf4906&scoped=true&lang=css"

import exportComponent from "../../../../../../ss/CT/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1bf4906"]])

export default __exports__